import { render, staticRenderFns } from "./CreateNpa.vue?vue&type=template&id=4f59c13a"
import script from "./CreateNpa.vue?vue&type=script&lang=js"
export * from "./CreateNpa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports